export default __webpack_public_path__ + "static/carousell-os-car-valuation-40k-cars-sold-6914e5b386c3e700eb566ff9f83b40d3.svg";